import { apiConcurso } from './cliente';

// ── Listagem / CRUD ──

/**
 * GET /api/v1/concursos/abertos
 * [AllowAnonymous] — lista concursos com inscrições abertas no tenant (via X-Tenant-Slug).
 */
export const listarConcursosAbertos = () => apiConcurso.get('/api/v1/concursos/abertos');

export const obterConcursoVigente = () => apiConcurso.get('/api/v1/concursos/vigente');

export const obterConcurso = (concursoId) => apiConcurso.get(`/api/v1/concursos/${concursoId}`);
